import(/* webpackMode: "eager" */ "/opt/thedesperatetrader/app/settings/page.tsx");
